import { Badge } from "@omony/ui";
import type { ReactNode } from "react";
import { useIntl } from "react-intl";
import styles from "./admin.module.css";

export function PageHead({ title, lead, actions }: { title: string; lead?: string; actions?: ReactNode }) {
  return (
    <header className={styles.pageHead}>
      <div>
        <h1 className={styles.pageTitle}>{title}</h1>
        {lead ? <p className={styles.pageLead}>{lead}</p> : null}
      </div>
      {actions ? <div className={styles.toolbar}>{actions}</div> : null}
    </header>
  );
}

export function StatusBadge({ status, temporarilyLocked }: { status: string; temporarilyLocked?: boolean }) {
  const intl = useIntl();
  if (temporarilyLocked)
    return <Badge tone="warning">{intl.formatMessage({ id: "admin.status.temporarilyLocked" })}</Badge>;
  const tone = status === "aktiv" ? "success" : status === "gesperrt" ? "danger" : "neutral";
  return <Badge tone={tone}>{intl.formatMessage({ id: `admin.status.${status}` })}</Badge>;
}

export function MfaBadge({ enabled, required }: { enabled: boolean; required: boolean }) {
  const intl = useIntl();
  if (enabled) return <Badge tone="success">{intl.formatMessage({ id: "admin.mfa.enabled" })}</Badge>;
  return (
    <Badge tone={required ? "danger" : "neutral"}>
      {intl.formatMessage({ id: required ? "admin.mfa.missing" : "admin.mfa.optionalOff" })}
    </Badge>
  );
}
